import { useEffect, useRef, useState } from "react";
import { isMobile, scroll2Top, mapCoverageType} from "../utils/utils";
import GuarantyCompareBloc from "../blocs/guaranty/GuarantyCompareBloc";
import GuarantyOfferBloc from "../blocs/guaranty/GuarantyOfferBloc";
import useAppState from "../context/AppContext";
import useFetchGaranties from "../hooks/useFetchGaranties";
import LoaderModal from "../modals/common/LoaderModal";
import { IOffersDetails, IPerson, relationType, ISimulateOffers, regimeType, garanteeType, simulationProcessType } from "../context/model";
import { calculOffers } from "../utils/dataUtils";



export default function GuarantyPage() {

  const {
    state: { updatedProposition, proposition, additionalData, jwtToken },
  
  } = useAppState();

    const [isShowComparePage, setIsShowComparePage] = useState<boolean | undefined>(false);
    const [options, setOptions] = useState<Record<string, IOffersDetails | null>>({});

    const arrChildren = updatedProposition?.beneficiaries?.filter(el => el.relationType === relationType.CHILD);
    let resultChildren = [] as IPerson[];
    arrChildren?.forEach((child) => {
        resultChildren.push({
            birthDate: child.contact.birthDate,
            regimeType: child?.contact.alsaceMoselleRegime ? regimeType.ALSACE_MOSELLE : regimeType.GENERAL
        });
    });
    
    const effectiveDateStr = proposition?.effectiveDate ? new Date(proposition.effectiveDate).toISOString().split('T')[0] : null;

    const fetchTotal = async (coverageType?: string ) => {
      if (jwtToken) {
        const token = jwtToken.accessToken;
        const body = {
          garanteeType : garanteeType.MIOM_BASE,
          coverageType: mapCoverageType(coverageType as string),
          effectiveDate: effectiveDateStr,
          hasPartner: additionalData?.hasPartner,
          partner: additionalData?.hasPartner ? {
            birthDate: updatedProposition?.beneficiaries?.find(el => el.relationType !== relationType.CHILD)?.contact.birthDate,
            regimeType: updatedProposition?.beneficiaries?.find(el => el.relationType !== relationType.CHILD)?.contact.alsaceMoselleRegime ? regimeType.ALSACE_MOSELLE : regimeType.GENERAL
          } as IPerson : null,
          hasChild: additionalData?.hasChild,
          children: resultChildren,
          regimeType: updatedProposition?.alsaceMoselleRegime ? regimeType.ALSACE_MOSELLE : regimeType.GENERAL,
          simulationProcessType: simulationProcessType.SIMULATION,
          salaryAmount: 0
        } as ISimulateOffers;
        const result = await calculOffers(token, body);   

        setOptions(opt => ({
          ...opt,
          [coverageType as string]: result
        }));
              
      }
    };
    

    const pageGapRef = useRef<null | HTMLDivElement>(null);
    useEffect(() => {
        if (isMobile()) {
        pageGapRef.current?.scrollIntoView() 
        } else {
        scroll2Top();
        }

        const types = garanties.map(el => el .code);
        types.forEach(type => fetchTotal(type)); 
        
    }, [updatedProposition?.offerCode]);

    const { loading, garanties } = useFetchGaranties();

    if (loading) {
      return <LoaderModal hasMessage={false}/>;
    } 

    return (
      <div className={!isMobile() ? "entreprise-container" : "bg-blanc"}>
        {!isMobile() && <h1 className="title ml-lg-desktop mb-sm">Souhaitez-vous renforcer votre couverture ?</h1>}
        <div ref={pageGapRef} className="page-gap" />
       
        <div className={!isMobile() ? "page-content flex-grid bg-blanc shadow-noir p-lg m-lg-desktop" : ""}>
            {
                isShowComparePage ?
                <GuarantyCompareBloc handleSwitchPage={() => {setIsShowComparePage(false)}} garanties={garanties} options={options}/> :
                <GuarantyOfferBloc handleSwitchPage={() => {setIsShowComparePage(true)}} garanties={garanties} options={options}/>
            }
           
        </div>
      </div>
    )

}